import { render, staticRenderFns } from "./OrganismAccordion.vue?vue&type=template&id=021dcf30&scoped=true&"
import script from "./OrganismAccordion.vue?vue&type=script&lang=js&"
export * from "./OrganismAccordion.vue?vue&type=script&lang=js&"
import style0 from "./OrganismAccordion.vue?vue&type=style&index=0&id=021dcf30&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021dcf30",
  null
  
)

export default component.exports